<div class="box-report-wrapper" [ngClass]="{'fixed_to_bottom': position === 'bottom'}"> 
    <small class="report-loader" *ngIf="state">{{ state }}</small>
  <div class="box-report">
    <div class="loader-report">
      <div class="o"></div>
      <div class="o"></div>
      <div class="o"></div>
      <div class="o"></div>
    </div>
  </div>
</div>